var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(!_vm.isLogin)?_c('Message'):_vm._e(),_c('Copyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }